<div *ngIf="reg">
  <ion-spinner *ngIf="loading"></ion-spinner>
  <span (click)="openRegistration()">
    <small><b>{{'LastReg' | translate}}:</b>&nbsp;<span>{{reg.signedAt | date:'HH:mm dd.MM.yy'}}</span></small>
    <ion-icon name="chevron-forward"></ion-icon>
  </span>
</div>